import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { microServiceLoggingInterceptor } from './core/interceptors/micro-service-logging.interceptor';
 // add this to break the cycle for custom dashboard layout
import { CURRENT_USER_ACCESSOR } from './core/services/auth-user.token';


export function initApp(authService: AuthService) {
  // Return the observable so Angular subscribes to it, triggering a fresh
  // `/auth/get-setting` fetch on every app load (incl. hard refresh) so
  // route changes are picked up. The cached routes are restored synchronously
  // inside the call as a fallback.
  return () => authService.restoreDynamicRoutesOnReload();
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), 
      withInterceptors([microServiceLoggingInterceptor]),
      withInterceptorsFromDi(),
    ),

    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation() 
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService],
      multi: true,
    },
    // add this to break the cycle for custom dashboard layout
    { provide: CURRENT_USER_ACCESSOR, useExisting: AuthService },

    provideAnimations()
  ]
};
